import {Component} from '@angular/core';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {EventItemDto} from "../../contracts/event-item.dto";
import {EventService} from "../../services/events/event.service";
import {NavbarComponent} from "../../components/navbar/navbar.component";
import {NgForOf} from "@angular/common";
import {EventItemComponent} from "./item/event-item.component";
import {EventsBaseComponent} from "../../shared/events-base.component";

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [TranslateModule, NavbarComponent, NgForOf, EventItemComponent],
  templateUrl: './events.component.html'
})
export class EventsComponent extends EventsBaseComponent<EventItemDto> {

  constructor(languageService: TranslateService, eventService: EventService) {
    super(languageService);
    this.evService = eventService;
  }

}
